import React, { Component } from "react"
import {
  Authenticator,
  RequireNewPassword,
  VerifyContact
} from "aws-amplify-react"

import { ArchieAuthTheme } from "./theme"
import { ArchieConfirmSignUp } from "./ArchieConfirmSignUp"
import { ArchieForgotPassword } from "./ArchieForgotPassword"
import { ArchieSignIn } from "./ArchieSignIn"
import { ArchieConfirmSignIn } from "./ArchieConfirmSignIn"
import { ArchieSignUp } from "./ArchieSignUp"
import { AuthHeading } from "./AuthHeading"

import "./Auth.scss"


export class SimpleAuthenticator extends Component {
  render() {
    return (
      <div className="auth">
        <Authenticator
          hideDefault={true}
          usernameAttributes="email"
          theme={ArchieAuthTheme}
          authState="signUp"
        >
          <AuthHeading/>
          <ArchieSignIn/>
          <ArchieConfirmSignIn/>
          <ArchieForgotPassword/>
          <ArchieSignUp/>
          <RequireNewPassword/>
          <ArchieConfirmSignUp/>
          <VerifyContact/>
        </Authenticator>
      </div>
    )
  }
}

export default SimpleAuthenticator
